var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"adminUserList"},[_c('Breadcumb',{attrs:{"title":"Plan d'actions","breadcumb-data":_vm.breadcumbData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }